// extracted by mini-css-extract-plugin
export default {"videoForm":"quizForm_videoForm__Pq1Hl"};